import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="What is an AI prompt" className="border-y border-line bg-ink" data-id="element-273" data-mp="3mkdfzmsnfz7t">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "12px"
    }} data-id="element-274" data-mp="37nw5exsaaomb">
        <div className="text-center" data-id="element-275" data-mp="3cn8t1kqzbzpy">
          <h2 className="font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-276" data-mp="3coahcqx0aipm">What is an AI prompt?</h2>
          <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-fog/70" data-id="element-277" data-mp="2yospu3sbsrck">
            An instruction you give an AI assistant to guide the response it generates. A{' '}
            <span className="font-bold text-teal" data-id="element-278" data-mp="ww4f79dcr1mr">structured prompt</span> explains the task, provides context, specifies the
            format, and identifies the information the AI should use.
          </p>
        </div>

        <PromptFlow data-id="element-279" data-mp="30futtxojgq4n" />
        <p className="mx-auto mt-6 max-w-2xl text-center text-sm text-fog/60" data-id="element-280" data-mp="2wglxcl246e5e">
          You don't need to be an AI expert. You need a clear task, an appropriate prompt, accurate source information, and a
          careful review of the result.
        </p>

        <PromptDemo data-id="element-281" data-mp="359fs7qu1nm4d" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-282" data-mp="35b0c8miqfmnz">
          <h3 className="text-center font-display text-2xl font-bold uppercase text-fog sm:text-3xl" data-id="element-283" data-mp="2hk4mduxu71jd">Example prompts from the system</h3>
          <p className="mt-2 text-center text-sm text-fog/60" data-id="element-284" data-mp="2djksd08k8e1g">Customize the gold fields with your details and copy into a compatible AI assistant.</p>

          <div role="tablist" aria-label="Sample prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-285" data-mp="2mhwo1goaa20r">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/50 ${active === i ? 'bg-teal text-ink' : 'border border-line bg-ink-2 text-fog/70 hover:text-fog'}`} data-id="element-286" data-mp="6t4tbls5hkc7" data-mpi={i}>
                #{sp.n} · {sp.title}
              </button>)}
          </div>

          <div className="mt-5" role="tabpanel" data-id="element-287" data-mp="nr39becw6nfc">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-288" data-mp="3ma1t9fuig8kr" />
          </div>
        </div>
      </div>
    </section>;
}